<template>
	<div style="width: 100%;" class="d-flex">
		<div style="width: 17%;margin-right: 1%;height: 700px;background: #fff;">
			<div class="d-flex">
				<div class="acs" style="border-top-left-radius: 5px;border-bottom-left-radius: 5px;" @click="alldata">全选</div>
				<div class="acs" style="border-top-right-radius: 5px;border-bottom-right-radius: 5px;" @click="gosx">筛选</div>
			</div>
			<div class="search-option">
				<el-tree :data="data" show-checkbox default-expand-all :props="defaultProps" @check="currentChecked"></el-tree>
			</div>
		</div>
		<div style="width: 82%;">
			<button-search ref="buttonSearch" placeholder="要搜索的商品名称" @search="searchEvent">
				<!-- 左边 -->
				<template #left>
					<el-button type="danger" size="mini" v-if="tab != 'delete'" @click="deleteAll" icon="el-icon-delete">删除</el-button>
					<el-button type="success" size="mini" icon="el-icon-bottom">导出</el-button>
				</template>

				<!-- 高级搜索表单 -->
				<template #form>
					<el-form inline ref="form" :model="form" label-width="80px">
						<el-form-item label="商品名称" class="mb-0"><el-input v-model="form.title" placeholder="商品名称" size="mini"></el-input></el-form-item>
						<el-form-item label="商品分类" class="mb-0">
							<el-select v-model="form.category_id" placeholder="请选择商品分类" size="mini">
								<el-option v-for="item in cateOptions" :key="item.id" :label="item | tree" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item class="mb-0">
							<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
							<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
						</el-form-item>
					</el-form>
				</template>
			</button-search>

			<!-- 商品列表 -->
			<el-table class="mt-3" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" size="mini" :max-height="maxHeight">
				<el-table-column type="selection" width="42" align="center"></el-table-column>
				<el-table-column align="center" prop="id" width="60" label="编号"></el-table-column>
				<el-table-column label="交易号" width="80">
					<template slot-scope="scope">
						<div class="media" style="display: flex;align-items: center;">{{ scope.row.jyh }}</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="szje" width="80" label="收支金额"></el-table-column>
				<el-table-column align="center" width="100" label="审核状态">
					<template slot-scope="scope">
						<el-button type="info" size="mini" plain v-if="scope.row.shzt == 0">待审核</el-button>
						<el-button type="success" size="mini" plain v-else-if="scope.row.shzt == 1">已通过</el-button>
						<el-button type="warning" size="mini" plain v-else>不通过</el-button>
					</template>
				</el-table-column>
				<el-table-column align="center" width="100" label="结算状态">
					<template slot-scope="scope">
						<el-button type="info" size="mini" plain v-if="scope.row.jszt == 0">待结算</el-button>
						<el-button type="success" size="mini" plain v-else>已结算</el-button>
					</template>
				</el-table-column>
				<el-table-column align="center" width="130" label="收付款账户">
					<template slot-scope="scope">
						<el-button type="info" size="mini" v-if="scope.row.skzh == null" plain>无</el-button>
						<el-button type="success" size="mini" v-else plain>{{scope.row.skzh.mc}}</el-button>
					</template>
				</el-table-column>
				<el-table-column align="center" width="100" label="收入类别">
					<template slot-scope="scope">
						<el-button type="info" size="mini" plain v-if="scope.row.srlb == null">无</el-button>
						<el-button type="success" size="mini" plain v-else>{{scope.row.srlb.mc}}</el-button>
					</template>
				</el-table-column>
				<el-table-column align="center" width="100" label="支出类别">
					<template slot-scope="scope">
						<el-button type="info" size="mini" plain v-if="scope.row.zclb == null">无</el-button>
						<el-button type="success" size="mini" plain v-else>{{scope.row.zclb.mc}}</el-button>
					</template>
				</el-table-column>
				<el-table-column align="center" width="130" label="单据类型">
					<template slot-scope="scope">
						<el-button type="info" size="mini" plain v-if="scope.row.djlx == null">无</el-button>
						<el-button type="success" size="mini" plain v-else>{{scope.row.djlx}}</el-button>
					</template>
				</el-table-column>
				<el-table-column align="center" width="100" label="业务员">
					<template slot-scope="scope">
						<el-button type="success" size="mini" plain>{{scope.row.ywy.name}}</el-button>
					</template>
				</el-table-column>
				<el-table-column align="center" width="100" label="创建时间">
					<template slot-scope="scope">
						{{scope.row.create_time.slice(0,10)}}
					</template>
				</el-table-column>
				<el-table-column align="center" width="100" label="结算日期">
					<template slot-scope="scope">
						{{scope.row.create_time.slice(0,10)}}
					</template>
				</el-table-column>
				<!-- 操作 -->
				<el-table-column align="center" label="操作" fixed="right" width="240">
					<template slot-scope="scope">
						<div v-if="tab != 'delete'">
							<el-button type="primary" size="mini" @click="openModel(scope.row)">查看</el-button>
							<el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
							<el-select v-model="value" placeholder="更多" size="mini" style="width: 75px;margin-left: 10px;">
								<el-option value="1"><p @click="gotos('zjb_khzl')">打印报表</p></el-option>
								<el-option value="2"><p @click="gotos('zjb_khzl')">查看关联</p></el-option>
							</el-select>
						</div>
						<div v-else>暂无操作</div>
					</template>
				</el-table-column>
			</el-table>
			<div style="height: 60px;"></div>
			<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 510px;right: 0;z-index: 100;">
				<div style="flex: 1;" class="px-2">
					<el-pagination
						:current-page="page.current"
						:page-sizes="page.sizes"
						:page-size="page.size"
						layout="total, sizes, prev, pager, next, jumper"
						:total="page.total"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
					></el-pagination>
				</div>
			</el-footer>
		</div>
		<el-dialog title="账单详情" :visible.sync="createModel" top="5vh" customClass="customWidth">
			<!-- 表单内容 -->
			<div style="width: 100%;" class="d-flex">
				<div style="width: 33%;">
					<el-form ref="formlist" :model="formlist" label-width="80px">
						<el-form-item label="信息编号">
							<el-input v-model="formlist.id" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="部门">
							<el-button type="info" size="mini" v-if="formlist.bm == null">无</el-button>
							<el-button type="success" size="mini" v-else>{{formlist.bm.name}}</el-button>
						</el-form-item>
						<el-form-item label="订单备注">
							<el-input v-model="formlist.desc" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="客户">
							<el-button type="info" size="mini" v-if="formlist.kh == null">无</el-button>
							<el-button type="success" size="mini" v-else>{{formlist.kh.mc}}</el-button>
						</el-form-item>
						<el-form-item label="收款账户">
							<el-button type="info" size="mini" v-if="formlist.skzh == null">无</el-button>
							<el-button type="success" size="mini" v-else>{{formlist.skzh.mc}}</el-button>
						</el-form-item>
						<el-form-item label="单据类型">
							<el-button type="info" size="mini" v-if="formlist.djlx == null">无</el-button>
							<el-button type="success" size="mini" v-else>{{formlist.djlx}}</el-button>
						</el-form-item>
						<el-form-item label="订单来源">
							<el-button type="info" size="mini" v-if="formlist.ddly == null">未知来源</el-button>
							<el-button type="success" size="mini" v-else>{{formlist.djlx}}</el-button>
						</el-form-item>
						<el-form-item label="申请单">
							<el-button type="info" size="mini" v-if="formlist.bdsqd == null">无</el-button>
							<el-button type="success" size="mini" v-else>{{formlist.bdsqd}}</el-button>
						</el-form-item>
						<el-form-item label="审核状态">
							<el-button type="info" size="mini" v-if="formlist.shzt == 0">待审核</el-button>
							<el-button type="success" size="mini" v-else>已通过</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div style="width: 33%;">
					<el-form ref="formlist" :model="formlist" label-width="80px">
						<el-form-item label="创建人">
							<el-button type="success" size="mini">{{cjr}}</el-button>
						</el-form-item>
						<el-form-item label="名称">
							<el-input v-model="formlist.djlx" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="收支金额">
							<el-input v-model="formlist.szje" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="供应商">
							<el-button type="info" size="mini" v-if="formlist.gys == null">无</el-button>
							<el-button type="success" size="mini" v-else>{{formlist.gys.name}}</el-button>
						</el-form-item>
						<el-form-item label="结算方式">
							<el-button type="info" size="mini" v-if="formlist.jsfs == null">无</el-button>
							<el-button type="success" size="mini" v-else>{{formlist.jsfs}}</el-button>
						</el-form-item>
						<el-form-item label="收入类别">
							<el-button type="info" size="mini" v-if="formlist.srlb == null">无</el-button>
							<el-button type="success" size="mini" v-else>{{formlist.srlb.mc}}</el-button>
						</el-form-item>
						<el-form-item label="普通单">
							<el-button type="info" size="mini" v-if="formlist.bdptd == null">无</el-button>
							<el-button type="success" size="mini" v-else>{{formlist.bdptd}}</el-button>
						</el-form-item>
						<el-form-item label="结算状态">
							<el-button type="info" size="mini" v-if="formlist.jszt == 0">待结算</el-button>
							<el-button type="success" size="mini" v-else>已结算</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div style="width: 33%;">
					<el-form ref="formlist" :model="formlist" label-width="80px">
						<el-form-item label="业务员">
							<el-button type="info" size="mini" v-if="formlist.ywy == null">无</el-button>
							<el-button type="success" size="mini" v-else>{{formlist.ywy.name}}</el-button>
						</el-form-item>
						<el-form-item label="交易号">
							<el-input v-model="formlist.jyh" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="核销金额">
							<el-input v-model="formlist.hxje" size="mini" style="width: 95%;"></el-input>
						</el-form-item>
						<el-form-item label="项目">
							<el-button type="info" size="mini" v-if="formlist.xm == null">无</el-button>
							<el-button type="success" size="mini" v-else>{{formlist.xm.mc}}</el-button>
						</el-form-item>
						<el-form-item label="转入账户">
							<el-button type="info" size="mini" v-if="formlist.zrzh == null">无</el-button>
							<el-button type="success" size="mini" v-else>{{formlist.zrzh.mc}}</el-button>
						</el-form-item>
						<el-form-item label="支出类别">
							<el-button type="info" size="mini" v-if="formlist.zclb == null">无</el-button>
							<el-button type="success" size="mini" v-else>{{formlist.zclb.mc}}</el-button>
						</el-form-item>
						<el-form-item label="库存单">
							<el-button type="info" size="mini" v-if="formlist.bdkcd == null">无</el-button>
							<el-button type="success" size="mini" v-else>{{formlist.bdkcd}}</el-button>
						</el-form-item>
						<el-form-item label="是否挂账">
							<el-button type="info" size="mini" v-if="formlist.sfgz == 0">否</el-button>
							<el-button type="success" size="mini" v-else>已通过</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	// 引入注册
	components: {
		buttonSearch
	},
	data() {
		return {
			preUrl: 'cwmx', // api
			cjr:'',

			tablist:[],
			tabIndex: 0,
			tabbars: [
				{ name: '全部', key: 'all' },
				{ name: '收入记账', key: 'srjz' },
				{ name: '支出记账', key: 'zcjz' },
				{ name: '产品记账', key: 'cpjz' },
				{ name: '我创建的', key: 'min_stock' },
				{ name: '我关注的', key: 'min_stock' }
			],
			formlist: {},
			form: {},
			tableData: [],
			cateOptions: [],
			maxHeight:0,
			createModel: false,
			value: '更多',
			data: [{
					id: 1,
					label: '收入记账',
					children: [{
						id: 4,
						label: '收款订单',
			 		},{
						id: 5,
						label: '预收款订单',
			 		},{
						id: 6,
						label: '收回欠款',
			 		},{
						id: 7,
						label: '退还收入',
			 		},{
						id: 8,
						label: '借入/收押金等',
			 		},{
						id: 9,
						label: '转账取存',
			 		}]
				},{
					id: 2,
					label: '支出记账',
					children: [{
						id: 10,
						label: '付款订单',
			 		},{
						id: 11,
						label: '预付款订单',
			 		},{
						id: 12,
						label: '偿还欠款',
			 		},{
						id: 13,
						label: '退还支出',
			 		},{
						id: 14,
						label: '借出/交押金等',
			 		}]
				},{
					id: 3,
					label: '产品记账',
					children: [{
						id: 15,
						label: '采购出库收入',
			 		},{
						id: 16,
						label: '采购入库支出',
			 		},{
						id: 17,
						label: '库存处理收入',
			 		},{
						id: 18,
						label: '库存处理支出',
			 		},{
						id: 19,
						label: '产品销售收入',
			 		},{
						id: 20,
						label: '产品退货支出',
			 		}]
			}],
			defaultProps: {
				children: 'children',
				label: 'label'
			}
		};
	},
	filters: {
		tree(item) {
			if (item.level == 0) {
				return item.name;
			}
			let str = '';
			for (let i = 0; i < item.level; i++) {
				str += i == 0 ? '|--' : '--';
			}
			return str + ' ' + item.name;
		}
	},
	// 计算属性
	computed: {
		// 引入store-modules的user模块里面的user(存储用户相关的数据)
		...mapState({
			user: state => state.user.user,
			navBar: state => state.menu.navBar
		}),
		// 订单类型
		tab() {
			return this.tabbars[this.tabIndex].key; //拿到key值，用来高级搜索
		},
		params() {
			let str = '';
			for (let key in this.form) {
				let val = this.form[key];
				if (val) {
					str += `&${key}=${this.form[key]}`;
				}
			}
			return str;
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 274; //300是页面中除了表格外其他组件的高度
		});
	},
	methods: {
		alldata(){
			this.tabIndex = 0
			this.getList()
		},
		getList() {
			if(this.preUrl == '') return
			this.showLoading()
			let url = this.getListUrl()
			this.axios.get(url, { // 商品规格 api
				token: true
			}).then(res => {
				let data = res.data.data
				this.page.total = data.totalCount // 获取分页信息
				this.getListResult(data) // 获取到的数据储存到getListResult(data)，方便外面调用修改
				this.hideLoading()
			}).catch(err => {
				this.hideLoading()
			})
		},
		gosx(e){
			// this.tabIndex = e
			// this.getList()
			// console.log(this.tablist);
		},
		currentChecked (nodeObj, SelectedObj) {
			let ids = SelectedObj.checkedNodes
			if(ids.length>0){
				if(ids[0].id == 1){
					this.tabIndex = 1
					this.getList()
				}else if(ids[0].id == 2){
					this.tabIndex = 2
					this.getList()
				}else if(ids[0].id == 3){
					this.tabIndex = 3
					this.getList()
				}
			}
		      console.log(SelectedObj.checkedNodes)  // 这是选中的节点数组  
 
		},
		gotos(e) {
			this.$router.push({
				name: e
			});
		},
		// 获取请求列表分页url
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}${this.params}`;
		},
		// 获取列表 可修改
		getListResult(e) {
			this.tableData = e.list;
			this.cateOptions = e.cates;
		},
		// 清空筛选条件
		clearSearch() {
			this.form = {
				title: '',
				category_id: ''
			};
		},
		// 搜索事件
		searchEvent(e = false) {
			// 简单搜索
			if (typeof e === 'string') {
				this.form.title = e;
			}
			// 高级搜索
			this.getList();
		},
		openModel(e = false) {
			this.formlist = e
			this.cjr = this.formlist.cjr.name
			this.createModel = true;
		},
	}
};
</script>

<style scoped>
.acs {
	background: #00c240;
	color: #fff;
	font-size: 14px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 30px;
}
.acs:hover {
	background: #00f150;
}
.search-option >>>.el-tree-node__label {
    font-size: 12px;
}
.el-form-item{
	margin-bottom:10px
}
</style>
